export default __webpack_public_path__ + "static/media/IconDesc_Pipes.256.fea503a0.png";